// tslint:disable:no-var-requires no-require-imports
export const foldersImage: string = require("../../../../assets/images/menu-icons/folders.png");
export const pencilImage: string = require("../../../../assets/images/menu-icons/equalizer-pencil.png");
export const toolboxImage: string = require("../../../../assets/images/menu-icons/toolbox.png");
export const tablesImage: string = require("../../../../assets/images/menu-icons/tables.png");
export const questionImage: string = require("../../../../assets/images/menu-icons/question.png");
export const questionMarkBlueImage: string = require("../../../../assets/images/question-mark-blue-circle.svg");
